/**
 * Checks if the code is running on the server (SSR) or in the browser (CSR).
 */
export const checkIsSsr = () => {
  return typeof window === 'undefined';
};
